module.exports = __webpack_public_path__ + "img/2024big5.36422678.png";